// askAssistant opens the floating AI command bar with a seeded prompt, starting
// a fresh conversation. This is the one handoff any surface uses to say "let the
// assistant take this from here" — the settings-page "Suggest with AI" buttons,
// the coach cards, and the setup wizard all route through it.
//
// The AICommandBar (mounted once in DashboardShell) listens for this event, so
// callers don't need to navigate anywhere first; the panel opens over whatever
// page the user is on.
export function askAssistant(prompt: string) {
  window.dispatchEvent(new CustomEvent('ai-command-bar:submit', { detail: { prompt } }));
}
